import { render, staticRenderFns } from "./zmdet.vue?vue&type=template&id=4fa4848e&scoped=true&"
import script from "./zmdet.vue?vue&type=script&lang=js&"
export * from "./zmdet.vue?vue&type=script&lang=js&"
import style0 from "./zmdet.vue?vue&type=style&index=0&id=4fa4848e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4848e",
  null
  
)

export default component.exports